export class Countdown {
    el;
    currentTime;
    timeRemaining;
    days;
    hours;
    mins;
    constructor(el) {
        this.el = el;
        this.days = el.querySelector('.days');
        this.hours = el.querySelector('.hours');
        this.mins = el.querySelector('.minutes');
        this.currentTime = new Date().getTime();
        this.timeRemaining = this.currentTime;
        const date = el.getAttribute('data-date');
        if (date) {
            const expiredDate = new Date(date);
            this.timeRemaining = expiredDate?.getTime() - this.currentTime;
            this.setExpiredDate();
        }
    }
    setExpiredDate() {
        this.timeRemaining <= 0 ?
            this.complete() :
            this.start();
    }
    complete() {
    }
    getTime() {
        return {
            days: Math.floor(this.timeRemaining / 1000 / 60 / 60 / 24),
            hours: Math.floor(this.timeRemaining / 1000 / 60 / 60) % 24,
            mins: Math.floor(this.timeRemaining / 1000 / 60) % 60
        };
    }
    update() {
        const time = this.getTime();
        if (this.days)
            this.days.innerHTML = time.days.toString();
        if (this.hours)
            this.hours.innerHTML = time.hours.toString();
        if (this.mins)
            this.mins.innerHTML = time.mins.toString();
    }
    start() {
        const intervalId = setInterval(() => {
            this.timeRemaining -= 1000;
            if (this.timeRemaining < 0) {
                // call the callback
                //complete();
                // clear the interval if expired
                clearInterval(intervalId);
            }
            else {
                this.update();
            }
        }, 1000);
    }
}
